module.exports = __webpack_public_path__ + "static/lola-cd7729072e12c58ba0b411c76ddf94b4.jpg";